import CompaniesContainer from './companies.container';

export default CompaniesContainer;
